import React, { useState } from 'react';
import About from './Aboutus';


const HeroSection = () => {
   const [showPdf, setShowPdf] = useState(false);
  
    const openPdf = () => {
      setShowPdf(true);
    };
  
    const closePdf = () => {
      setShowPdf(false);
    };
  return (
    <section className="hero-section" id="about">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            
            <h1 className="hero-title">
              В мир пространственных данных с нами
            </h1>
            
            <div className="hero-buttons">
              <a href="#aboutus" className="btn btn-outline">
                О нас
              </a>
              <a href="#contact" className="btn btn-primary">
                <button onClick={openPdf} className="pdf-link">Наши разработки</button>
              </a>
            </div>
          </div>
          
          <div className="hero-image-container">
            <img
              src="/images/logoenjoy.svg"
              alt="Enjoybymap"
              className="hero-image"
              width={300}
              height={300}
            />
          </div>
        </div>
      </div>
      {/* Модальное окно для PDF */}
      {showPdf && (
        <div className="pdf-modal">
          <div className="pdf-modal-content">
            <button className="pdf-modal-close" onClick={closePdf}>
              &times;
            </button>
            <iframe 
              src="/Commercial_proposal.pdf" 
              title="Документ предприятия"
              width="100%" 
              height="100%"
              frameBorder="0"
            >
              Ваш браузер не поддерживает PDF. Вы можете 
              <a href="/Commercial_proposal.pdf">скачать файл</a>.
            </iframe>
          </div>
        </div>
      )}
    </section>
    
  );
};

export default HeroSection;